import type { CorrectionsReportData } from "../../services/correctionRequestService";
import styles from "./BillingReportPrint.module.css";

interface CorrectionsPrintReportProps {
  report: CorrectionsReportData;
}

export function CorrectionsPrintReport({
  report,
}: CorrectionsPrintReportProps) {
  return (
    <main className={styles.page} data-billing-report-document="true">
      <h1 className={styles.title}>Corrections Queue</h1>
      <p className={styles.metadataLine}>Generated At: {report.generatedAt}</p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Case Number</th>
            <th>Changes</th>
            <th>Accessioned By</th>
            <th>Corrected By</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {report.rows.length === 0 && (
            <tr>
              <td className={styles.empty} colSpan={5}>
                No corrected cases match the selected filters.
              </td>
            </tr>
          )}
          {report.rows.map((row, index) => (
            <tr
              key={`${row.caseNumber ?? "unknown"}:${row.correctedAt}:${index}`}
            >
              <td>{row.caseNumber ?? "—"}</td>
              <td className={styles.changes}>{row.changes}</td>
              <td>{row.accessionedBy ?? "—"}</td>
              <td>{row.correctedBy ?? "—"}</td>
              <td>{row.correctedAt}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
